import { isDevMode } from '@angular/core';

import {
  AMP_PSEUDO_LOCALE_QUERY,
  AMP_PSEUDO_LOCALE_STORAGE_KEY,
} from './defaults';

export function capturePseudoLocaleFromLocation(
  search = globalThis.location?.search ?? '',
): void {
  if (!isDevMode()) {
    return;
  }

  const enabled =
    new URLSearchParams(search).get(AMP_PSEUDO_LOCALE_QUERY) === '1';

  if (!enabled) {
    return;
  }

  try {
    sessionStorage.setItem(AMP_PSEUDO_LOCALE_STORAGE_KEY, '1');
  } catch {
    // privacy mode
  }
}

export function isPseudoLocaleEnabled(): boolean {
  if (!isDevMode()) {
    return false;
  }

  try {
    return sessionStorage.getItem(AMP_PSEUDO_LOCALE_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function wrapPseudoLocale(value: string): string {
  return `[!!! ${value} !!!]`;
}
